import LazyLoad from 'vanilla-lazyload';
window.LazyLoad = LazyLoad;
window.lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    cancel_on_exit: false,
    threshold: 500
});
